import React from "react";
import CommonStringParser from "@/src/shared/components/CommonStringParser";
import type { IListing } from "@/src/shared/types/listing";
import { timeFormatting } from "@/src/shared/utils/timeFunctionsModel";
import ShowMore from "@/src/shared/components/atoms/ShowMore";

interface IHostBasicInfoProps {
  singleListingData: IListing;
}

const BookingModalBasicInfo: React.FC<IHostBasicInfoProps> = ({
  singleListingData,
}) => {
  return (
    <>
      {/* Info */}
      <section>
        <h3 className="text-base font-semibold text-ink-black mb-1.5">
          Getting there
        </h3>
        <p className="text-sm text-black font-normal">
          Check-in time for this home starts at{" "}
          {singleListingData?.check_in &&
            timeFormatting(singleListingData.check_in)}
          &nbsp; and checkout is at&nbsp;
          {singleListingData?.check_out &&
            timeFormatting(singleListingData.check_out)}
          .
        </p>
      </section>

      {/* Price */}
      <section>
        <h3 className="text-base font-semibold text-ink-black mb-1.5">
          Cancellation Policy
        </h3>
        <div className="!text-sm text-black font-normal rounded-2xl">
          <ShowMore className="" lines={1} more="See more" less="See less">
            <CommonStringParser
              dangerHtml={
                singleListingData?.cancellation?.body
                  ?.split("\n")
                  .join("<br/>") || ""
              }
            />
          </ShowMore>
        </div>
      </section>
    </>
  );
};

export default BookingModalBasicInfo;
